import Button from '@mui/material/Button';
import { styled } from '@mui/material';

const CustomButton = styled(Button)(() => ({
  borderRadius: "10px",
  height: "40px",
}));

export default CustomButton;